import { render, staticRenderFns } from "./FornecedorListaPrecos.vue?vue&type=template&id=47802ffc&"
import script from "./FornecedorListaPrecos.vue?vue&type=script&lang=js&"
export * from "./FornecedorListaPrecos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports